import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner, Container } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const LoggedOutRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation(); // Get current location

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  return !user ? children : <Navigate to="/" replace state={{ from: location }} />;
};

export default LoggedOutRoute;
